import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { agreements } from '../../../../shared/utils/agreement';

const TermsContainer = styled.div`
  padding: 20px 80px;

  @media (max-width: 599px) {
    padding: 20px 10px;
  }
`;

const TermsHeading = styled.div`
  font-weight: 700;
  font-size: 25px;
`;

export const PrivacyPolicy = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.agreement',
  });

  return (
    <TermsContainer>
      <TermsHeading id="personalInformation">
        {t('personalInformation')}
      </TermsHeading>
      <div
        dangerouslySetInnerHTML={{
          __html: agreements.personalInformationV2,
        }}
      />
    </TermsContainer>
  );
};
